export const readFile = async (file: File) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => {
      reader.abort();
      reject(reader.error);
    };
    reader.readAsText(file);
  });
